export const ENTRIES_PER_PAGE = 24